import React, { forwardRef, Fragment, useState, useEffect } from "react";
import UploadButtonInput from "ReusableComponents/UploadButtonInput";
import cloneDeep from "lodash.clonedeep";
import { Input, Row, Col, Typography } from 'antd';
import Checkbox from "antd/es/checkbox/index";
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import TranslatedText from "translations/TranslatedText";
import URLConfig from './URLConfig';
import TextConfig from './TextConfig';
import Select from "antd/es/select/index";
import FormItem from "antd/es/form/FormItem";

export default forwardRef((props: any, ref) => {
  const {
    mediaFiles,
    ...rest
  } = props;
  const isImage = mediaFiles.find((media:any) => 'src' in media || 'file' in media);
  const [config, setConfig] = useState(isImage ? "image" : "text")

  return (
    <Fragment>
      <Select defaultValue={config}
              onChange={setConfig}
      >
        <Select.Option value="text">text</Select.Option>
        <Select.Option value="image">image</Select.Option>
      </Select>
      {config === "text" && <TextConfig {...rest}
                                        mediaFiles={mediaFiles}
                            />
      }
      {config === "image" && <URLConfig {...rest}
                                        mediaFiles={mediaFiles}
                            />
      }
    </Fragment>
  );
});
